import { render, staticRenderFns } from "./StaffDashboard.vue?vue&type=template&id=ec76f738"
import script from "./StaffDashboard.vue?vue&type=script&lang=js"
export * from "./StaffDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports